module.exports = __webpack_public_path__ + "img/bg4.de0c7df5.jpg";